import InlineHintsDemo from "../../games/origami/components/ui/InlineHintsDemo";

export const TUTORIAL_STEPS = [
  {
    id: "welcome",
    title: "Bienvenue dans Projet Origami",
    description: "Découvrez l'interface de jeu",
    spotlightZone: null,
    content: (
      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        {[
          { icon: "🎧", label: "Communication obligatoire", text: "Discord, Zoom, Teams, utilisez votre outil de communication habituel." },
          { icon: "🚪", label: "Salles différentes", text: "Chaque joueur explore une zone unique." },
          { icon: "🤝", label: "Partagez les infos", text: "La collaboration est essentielle. N'hésitez pas à communiquer vos trouvailles." },
          { icon: "⏱️", label: "60 minutes", text: "Pour résoudre l'enquête." },
        ].map((item, i) => (
          <div key={i} style={{ display: "flex", alignItems: "flex-start", gap: 10, padding: "8px 10px", borderRadius: 8, background: "rgba(255,255,255,.03)", border: "1px solid rgba(255,255,255,.06)" }}>
            <span style={{ fontSize: 16, flexShrink: 0 }}>{item.icon}</span>
            <div>
              <div style={{ fontSize: 12, fontWeight: 700, color: "rgba(226,232,240,.9)", fontFamily: "ui-sans-serif,system-ui", marginBottom: 2 }}>{item.label}</div>
              <div style={{ fontSize: 11, color: "rgba(148,163,184,.75)", fontFamily: "ui-sans-serif,system-ui", lineHeight: 1.5 }}>{item.text}</div>
            </div>
          </div>
        ))}
      </div>
    ),
  },
  {
    id: "timer",
    title: "⏱️ Timer",
    description: "Suivez le temps restant en haut à gauche",
    spotlightZone: "timer",
    content: (
      <p style={{ fontSize: 12, color: "rgba(148,163,184,.85)", fontFamily: "ui-sans-serif,system-ui", lineHeight: 1.6 }}>
        Le <strong style={{ color: "rgba(226,232,240,.9)" }}>timer</strong> décompte le temps restant. Il passe au <span style={{ color: "rgba(253,186,116,.9)" }}>orange</span> puis au <span style={{ color: "rgba(252,165,165,.9)" }}>rouge</span> quand le temps presse.
      </p>
    ),
  },
  {
    id: "scenario-tracker",
    title: "📋 Journal de mission",
    description: "Suivez votre progression narrative",
    spotlightZone: "scenario-tracker",
    content: (
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        <p style={{ fontSize: 12, color: "rgba(148,163,184,.85)", fontFamily: "ui-sans-serif,system-ui", lineHeight: 1.6 }}>
          Le <strong style={{ color: "rgba(226,232,240,.9)" }}>journal de mission</strong> se remplit au fur et à mesure que vous progressez.
        </p>
        <p style={{ fontSize: 11, color: "rgba(100,116,139,.7)", fontFamily: "ui-sans-serif,system-ui" }}>
          Il liste les découvertes clés et les étapes franchies.
        </p>
      </div>
    ),
  },
  {
    id: "hand-raise",
    title: "✋ Lever la main",
    description: "Signalez que vous avez besoin d'aide",
    spotlightZone: "hand-raise",
    content: (
      <p style={{ fontSize: 12, color: "rgba(148,163,184,.85)", fontFamily: "ui-sans-serif,system-ui", lineHeight: 1.6 }}>
        Si vous souhaitez prendre la parole, levez la main pour <strong style={{ color: "rgba(226,232,240,.9)" }}>alerter vos coéquipiers</strong> sans les interrompre.
      </p>
    ),
  },
  {
    id: "workspace-mission",
    title: "📝 Onglet Mission",
    description: "Consultez vos objectifs actifs",
    spotlightZone: "workspace",
    highlightTab: "mission",
    content: (
      <p style={{ fontSize: 12, color: "rgba(148,163,184,.85)", fontFamily: "ui-sans-serif,system-ui", lineHeight: 1.6 }}>
        L'onglet <strong style={{ color: "rgba(226,232,240,.9)" }}>Mission</strong> affiche vos mini-objectifs en cours et les actions à mener. Il indique aussi les principales trouvailles de vos coéquipiers.
      </p>
    ),
  },
  {
    id: "workspace-notes",
    title: "🗒️ Onglet Notes",
    description: "Prenez des notes pendant l'enquête",
    spotlightZone: "workspace",
    highlightTab: "notes",
    content: (
      <p style={{ fontSize: 12, color: "rgba(148,163,184,.85)", fontFamily: "ui-sans-serif,system-ui", lineHeight: 1.6 }}>
        L'onglet <strong style={{ color: "rgba(226,232,240,.9)" }}>Notes</strong> vous permet de noter codes, indices, et observations importantes.
      </p>
    ),
  },
  {
    id: "workspace-shared",
    title: "📌 Onglet Partagés",
    description: "Envoyez des éléments à vos coéquipiers",
    spotlightZone: "workspace",
    highlightTab: "shared",
    content: (
      <p style={{ fontSize: 12, color: "rgba(148,163,184,.85)", fontFamily: "ui-sans-serif,system-ui", lineHeight: 1.6 }}>
        L'onglet <strong style={{ color: "rgba(226,232,240,.9)" }}>Partagés</strong> permet d'envoyer des infos et codes aux autres joueurs. Certains éléments viendront s'ajouter automatiquement lorsque vous les trouverez.
      </p>
    ),
  },
  {
    id: "room",
    title: "🔎 Zone de jeu",
    description: "Cliquez sur les éléments pour les inspecter",
    spotlightZone: "center-room",
    content: (
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        {[
          { icon: "🖱️", text: "Survolez l'image : les éléments cliquables s'illuminent." },
          { icon: "✨", text: "Cliquez pour inspecter : codes, indices, documents… mais aussi des fausses pistes." },
        ].map((tip, i) => (
          <div key={i} style={{ display: "flex", alignItems: "flex-start", gap: 10, padding: "8px 10px", borderRadius: 8, background: "rgba(255,255,255,.03)", border: "1px solid rgba(255,255,255,.06)" }}>
            <span style={{ fontSize: 15, flexShrink: 0 }}>{tip.icon}</span>
            <span style={{ fontSize: 12, color: "rgba(148,163,184,.85)", fontFamily: "ui-sans-serif,system-ui", lineHeight: 1.5 }}>{tip.text}</span>
          </div>
        ))}
      </div>
    ),
  },
  {
    id: "brief",
    title: "📨 Brief de mission",
    description: "Relisez les instructions à tout moment",
    spotlightZone: "brief",
    content: (
      <p style={{ fontSize: 12, color: "rgba(148,163,184,.85)", fontFamily: "ui-sans-serif,system-ui", lineHeight: 1.6 }}>
        Le bouton <strong style={{ color: "rgba(165,180,252,.9)" }}>BRIEF</strong> vous permet de relire le brief de mission à tout moment.
      </p>
    ),
  },
  {
    id: "team",
    title: "👥 Équipe",
    description: "Consultez vos coéquipiers",
    spotlightZone: "team",
    content: (
      <p style={{ fontSize: 12, color: "rgba(148,163,184,.85)", fontFamily: "ui-sans-serif,system-ui", lineHeight: 1.6 }}>
        Voyez qui est dans quelle salle et leur progression.
      </p>
    ),
  },
  {
    id: "room-preview",
    title: "🔍 Aperçu des salles",
    description: "Cliquez sur la vignette pour voir la salle d'un autre joueur",
    spotlightZone: "team",
    content: (
      <p style={{ fontSize: 12, color: "rgba(148,163,184,.85)", fontFamily: "ui-sans-serif,system-ui", lineHeight: 1.6 }}>
        Cliquez sur la <strong style={{ color: "rgba(226,232,240,.9)" }}>miniature 🔍</strong> à droite d'une carte joueur pour voir sa salle en grand.
      </p>
    ),
  },
  {
    id: "hints-intro",
    title: "💡 Système d'indices",
    description: "Plusieurs niveaux d'aide et la réponse en cas de besoin",
    spotlightZone: "hints-button",
    content: (
      <p style={{ fontSize: 12, color: "rgba(148,163,184,.85)", fontFamily: "ui-sans-serif,system-ui", lineHeight: 1.6 }}>
        Si vous bloquez, le bouton <strong style={{ color: "rgba(253,186,116,.9)" }}>INDICES</strong> ouvre un menu d'aide avec plusieurs niveaux.
      </p>
    ),
  },
  {
    id: "hints-modal",
    title: "💡 Niveaux d'indices",
    description: "3 niveaux d'indices et la réponse à chaque énigme sont accessibles.",
    spotlightZone: null,
    content: <InlineHintsDemo />,
  },
  {
    id: "ready",
    title: "🚀 Prêt à jouer ?",
    description: "Retournez dans la salle d'attente",
    spotlightZone: null,
    content: (
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        {[
          { icon: "✅", text: 'Cliquez "J\'ai compris" pour valider le tutoriel et retourner dans la salle d\'attente.' },
          { icon: "✅", text: 'Cliquez "Je suis prêt(e)" dans la salle d\'attente.' },
          { icon: "⏳", text: "Attendez que tout le monde soit prêt." },
          { icon: "🚀", text: "Une personne lance la partie (4–6 joueurs)." },
          { icon: "⚠️", text: "Le lancement de la partie est définitif et irréversible." },
        ].map((item, i) => (
          <div key={i} style={{ display: "flex", alignItems: "flex-start", gap: 10, padding: "7px 10px", borderRadius: 7, background: "rgba(255,255,255,.025)", border: "1px solid rgba(255,255,255,.05)" }}>
            <span style={{ fontSize: 13, flexShrink: 0 }}>{item.icon}</span>
            <span style={{ fontSize: 12, color: "rgba(148,163,184,.85)", fontFamily: "ui-sans-serif,system-ui", lineHeight: 1.5 }}>{item.text}</span>
          </div>
        ))}
      </div>
    ),
  },
];